import { useState, useEffect } from 'react'
import api, { IAssetTag } from '@api'

export default function useAsset(id: string) {
  const [asset, setAsset] = useState<IAssetTag>({
    id: '',
    name: '',
    totals: { employees: 0, spaces: 0 },
  })
  const [isLoading, setIsLoading] = useState(true)
  const [shouldReload, setShouldReload] = useState(false)

  useEffect(() => {
    api.asset.details(id).then((asset) => {
      setAsset(asset)
      setIsLoading(false)
    })
  }, [id])

  useEffect(() => {
    if (shouldReload) {
      api.asset.details(id).then(setAsset)
      setShouldReload(false)
    }
    // eslint-disable-next-line
  }, [shouldReload])

  return {
    asset,
    isLoading,
    updateAsset: (asset: IAssetTag) => setAsset(asset),
    reload: () => setShouldReload(true),
  }
}
